import { render, staticRenderFns } from "./source.vue?vue&type=template&id=2c4dda38"
import script from "./source.vue?vue&type=script&lang=ts"
export * from "./source.vue?vue&type=script&lang=ts"
import style0 from "./source.vue?vue&type=style&index=0&id=2c4dda38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports